export default __webpack_public_path__ + "static/media/atsDistribution.487b1351.png";